import Modal from "@/components/base/Modal";
import ContactForm from "@/components/feature/ContactForm";

interface ContactModalProps {
  open: boolean;
  onClose: () => void;
  memNo?: number | string;
  title?: string;
}

// 문의 폼 모달 (회원 상세의 [문의하기] 등에서 사용)
export default function ContactModal({ open, onClose, memNo, title }: ContactModalProps) {
  return (
    <Modal open={open} onClose={onClose} maxWidth="max-w-xl">
      <div className="p-6 md:p-7">
        <div className="mb-5 flex items-start justify-between">
          <div>
            <h2 className="font-heading text-lg font-bold text-foreground-950">
              {title || "문의하기"}
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              궁금하신 내용을 남겨주시면 확인 후 연락드리겠습니다.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="닫기"
            className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 hover:bg-background-100"
          >
            <i className="ri-close-line text-xl" aria-hidden="true"></i>
          </button>
        </div>
        <ContactForm memNo={memNo} compact />
      </div>
    </Modal>
  );
}